import Swiper, {Navigation} from 'swiper';
Swiper.use(Navigation);
import utils from '@/_modules/utils';

class _caseSwipe {
  constructor() {
    this.isStart = false;
  }

  start() {
    this.isStart = true;
  }

  init() {
    this.initSwiper();

    this.bindResize = this.resize.bind(this);
    window.addEventListener('resize', this.bindResize, {passive: false});
  }

  initSwiper() {
    this.swiper = new Swiper('.c-caseSlider', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 0,
      slidesPerView: 'auto',
      grabCursor: true,
      navigation: {
        nextEl: '.c-btnCase--right',
        prevEl: '.c-btnCase--left',
      },
      speed: 500,
      breakpoints: {
        // when window width is >= 320px
        501: {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 0,
        },
        1101: {
          slidesPerView: 'auto',
          centeredSlides: false,
          spaceBetween: 100
        },
      }
    });
  }

  resetSwiper() {
    if (this.swiper.length) {
      this.swiper.forEach((sw) => {
        sw.destroy();
      });
    } else {
      this.swiper.destroy();
    }
  }

  reset() {
    this.resetSwiper();

    window.removeEventListener('resize', this.bindResize);
    delete this.bindResize;
  }

  resize() {
    if (utils.getMatchMedia() || utils.getMatchMedia1800()) {
      ///////////////
      // SP or 1800px以上
      ///////////////
    } else {
      ///////////////
      // PC
      ///////////////
    }
  }
}

const caseSwipe = new _caseSwipe();

export default caseSwipe;